<template>
    <div class="container">
        <page-header :title="title"></page-header>
        <div class="content" :class="{ mini: total > 5 }" v-if="list.length > 0">
            <div class="item" v-for="item in list" :key="item.id" v-watermark>
                <div class="header">
                    <div class="left">患者：{{ item.userMemberName }}<span style="color: #4187f7;font-weight:normal;"
                            v-if="item.askType === 12 || item.askType === 13">（{{ { 12: '快速问诊', 13: '补方' }[item.askType]
                            }}）</span>
                    </div>
                    <div class="right">{{ item.createTime }}</div>
                </div>
                <div class="main">
                    <div class="row" v-if="item.memberRightsInterests">
                        <vip :id="item.id" :detail="item.memberRightsInterests" :is-view="false" />
                    </div>
                    <div class="row">
                        <div class="row-label">本次问诊病种</div>
                        <div class="row-value">
                            <template v-if="item.subDiseaseTypes">
                                <span v-for="(itm, idx) in item.subDiseaseTypes.split(',')" :key="idx">
                                    <span>{{ idx > 0 ? '、' : '' }}</span>
                                    <span :style="item.diseaseType === (itm | 0) ? 'color: #4187f7' : ''">{{
                                        getDiseaseTypeName(itm
                                            | 0) }}</span>
                                </span>
                            </template>
                            <span v-else>{{ getDiseaseTypeName(item.diseaseType) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-label">本次问诊主诉症状</div>
                        <div class="row-value">
                            <template v-if="item.askDiseaseList?.length">
                                <span v-for="(itm, idx) in item.askDiseaseList" :key="idx">
                                    <span>{{ idx > 0 ? "、" : "" }}</span>
                                    <span>{{ itm.name }}</span>
                                </span>
                            </template>
                            <span v-else>症状待确认</span>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="row-label">上次医院问诊结果</div>
                        <div class="row-value">{{item.icdName || item.diagnose || '暂无'}}</div>
                    </div> -->
                    <div class="row">
                        <div class="row-label">病情描述</div>
                        <div class="row-value">{{ item.askIllness }}</div>
                    </div>
                    <div class="store" v-if="item.origin == 2">
                        <div class="info">
                            <div class="cell">{{ item.originName }}</div>
                            <div class="cell">{{ item.receptionistName }} {{ item.receptionistMobile }}</div>
                        </div>
                        <div class="meeting" v-if="item.meetingNo">
                            <div class="num">视频问诊（会议号：{{ item.meetingNo }}）</div>
                            <div class="copy">
                                <co-copy :content="item.meetingNo">
                                    <van-button type="info" size="mini">复制</van-button>
                                </co-copy>
                            </div>
                        </div>
                    </div>
                    <div class="doctor row" v-if="item.doctorName">
                        <div>接诊医生：{{ item.doctorName || "-" }}</div>
                        <!-- <div class="btn" v-if="[0, 1].includes(item.state)" @click="onChangeDoctor(item)">修改接诊医生</div> -->
                    </div>
                </div>
                <div class="footer">
                    <!-- <div class="footer-left">来自客户：{{item.userInfoName}}</div> -->
                    <div class="footer-left">
                        <span>状态：</span>
                        <span>
                            <AskStatus :status="item.state" :exist-address="item.address" :ask-no="item.askNo" :star-time="item.askApplyTime" @init="getUserMemberPageListByUserNo" />
                        </span>
                    </div>
                    <!-- <div style="cursor:pointer;" class="base-button" @click="onCreateAsk(item)"
                        v-if="item.isPrescription === 1 && item.orderStatus === 1 && item.askType !== 13">补方</div> -->
                    <!-- <div style="color:red;cursor:pointer;" @click="onGoToOrder(item)"
                        v-if="item.state === 2 && item.isPrescription === 1">
                        发送订单支付页面</div> -->
                    <div class="footer-right" @click="inquiryInfo(item.askNo)">
                        <span>查看问诊信息</span>
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>
        </div>
        <van-empty description="暂无问诊记录" v-else />
        <pagination :page-no="searchData.pageNo" :total="total" @pageChange="pageChange" v-if="total > 5"></pagination>
        <prev-page :text="'返回'" @back="back"></prev-page>
        <van-popup v-model="changeDoctorState.show" position="bottom" :style="{ height: '80%' }" round closeable>
            <div class="popup-wrapper">
                <div class="popup-title">修改接诊医生</div>
                <div class="popup-content">
                    <div v-for="(item, index) in doctorList" :key="index" class="popup-item van-hairline--bottom"
                        :class="item.doctorNo === changeDoctorState.doctorNo ? 'popup-item-active' : ''"
                        @click="onItemClick(item)">
                        {{ item.name }}{{ item.doctorNo === changeDoctorState.oldDoctorNo ? '(默认)' : '' }}
                    </div>
                </div>
                <div class="popup-bottom">
                    <van-button type="info" native-type="button" class="button-box" @click.stop="onSaveChange">
                        确定
                    </van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getUserMemberPageListByUserNo } from '../../api/index.js'
import AskStatus from '@/components/ask/status.vue'
import coCopy from '@/components/common/copy.vue'
import vip from '@/components/vip/index.vue'
import { getEnterpriseWechatlist, updateDoctorOfAsk } from '@/api/home.js'
export default {
    components: {
        AskStatus,
        coCopy,
        vip
    },
    data() {
        return {
            title: '问诊记录',
            searchData: {
                userMemberId: '',
                pageNo: 1,
                pageSize: 5
            },
            list: [],
            total: 0,
            changeDoctorState: {
                show: false,
                askNo: '',
                doctorNo: '',
                oldDoctorNo: ''
            },
            doctorList: []
        }
    },
    computed: {
        ...mapGetters(['getDiseaseTypeName'])
    },
    activated() {
        if (this.$route.query.pageNo) {
            this.searchData.pageNo = this.$route.query.pageNo * 1
            let newQuery = JSON.parse(JSON.stringify(this.$route.query))
            delete newQuery.pageNo
            this.$router.replace({ query: newQuery })
        }
        this.searchData.userMemberId = this.$route.query.userMemberId
        this.getUserMemberPageListByUserNo()
    },
    methods: {
        getUserMemberPageListByUserNo() {
            getUserMemberPageListByUserNo(this.searchData).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.total = res.data.total
                }
            })
        },
        // 分页
        pageChange(val) {
            this.list = []
            this.searchData.pageNo = val
            this.getUserMemberPageListByUserNo()
        },
        back() {
            this.$router.back()
        },
        inquiryInfo(askNo) {
            this.$router.push({
                path: '/inquiryInfo',
                query: {
                    askNo
                }
            })
        },
        onCreateAsk(item) {
            this.$router.push({
                path: '/createAsk',
                query: {
                    askType: 13,
                    userNo: item.userNo,
                    userMemberId: item.userMemberId,
                    assistantNo: this.$store.state.assistantNo,
                    askNo: item.askNo
                }
            })
        },
        onGoToOrder(item) {
            this.$router.push({
                path: '/askOrder',
                query: {
                    userMemberId: item.userMemberId,
                    askNo: item.askNo
                }
            })
        },
        async onChangeDoctor({ askNo, doctorNo }) {
            try {
                const { data: { list } } = await getEnterpriseWechatlist({ doctorStatus: 0, pageNum: 1, pageSize: 999 })
                this.changeDoctorState = {
                    show: true,
                    askNo,
                    doctorNo,
                    oldDoctorNo: doctorNo
                }
                this.doctorList = (list || []).sort((a, b) => {
                    return a.doctorNo === doctorNo ? -1 : b.doctorNo === doctorNo ? 1 : 0
                })
            } catch (error) {
                console.log(error)
                this.doctorList = []
            }
        },
        onItemClick(row) {
            this.changeDoctorState.doctorNo = row.doctorNo
        },
        async onSaveChange() {
            try {
                await updateDoctorOfAsk({
                    askNo: this.changeDoctorState.askNo,
                    doctorNo: this.changeDoctorState.doctorNo
                })
                this.changeDoctorState.show = false
                this.getUserMemberPageListByUserNo()
                this.$toast('修改成功');
            } catch (error) {
                console.log(error)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.popup-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    .popup-title {
        padding: 20px;
        text-align: center;
        color: #333;
        font-weight: bold;
        font-size: 16px;
    }

    .popup-content {
        flex: 1;
        overflow: auto;
        padding: 20px;

        .popup-item {
            padding: 15px 0;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
        }

        .popup-item-active {
            background: #eff3fb;
            border-radius: 4px;
            color: #0082ef;
        }
    }

    .popup-bottom {
        height: 84px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 16px 25px;
        display: flex;

        .button-box {
            font-size: 18px;
            border: none;
            border-radius: 8px;
            width: 100%;
        }
    }
}

.container {
    padding: 0 15px;

    .content {
        height: calc(100vh - #{140px});
        overflow-y: auto;

        &.mini {
            height: calc(100vh - #{210px});
        }

        .item {
            background: #fff;
            border-radius: 8px;
            padding: 0 20px;
            margin-bottom: 10px;

            .header {
                display: flex;
                justify-content: space-between;
                padding: 16px 0;
                border-bottom: 1px solid #eee;
                align-items: center;

                .left {
                    color: #333;
                    font-size: 16px;
                    font-weight: bold;
                }

                .right {
                    color: #666;
                    font-size: 14px;
                }
            }

            .main {
                padding-top: 20px;
                border-bottom: 1px solid #eee;

                .row {
                    margin-bottom: 18px;

                    .row-label {
                        font-size: 12px;
                        color: #999;
                        margin-bottom: 6px;
                    }

                    .row-value {
                        font-size: 14px;
                        color: #333;
                        word-break: break-all;
                    }
                }

                .store {
                    margin-bottom: 18px;
                    font-size: 14px;

                    .info {
                        display: flex;
                        align-items: center;

                        .cell {
                            position: relative;

                            &:not(:first-child) {
                                margin-left: 5px;
                                padding-left: 5px;

                                &::before {
                                    content: "";
                                    position: absolute;
                                    left: 0;
                                    top: 3px;
                                    bottom: 3px;
                                    border-left: 1px solid #64696e;
                                }
                            }
                        }
                    }

                    .meeting {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 8px;

                        .num {
                            color: #f96164;
                        }
                    }
                }

                .doctor {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;

                    .btn {
                        background: #eff3fb;
                        border-radius: 4px;
                        padding: 5px 18px;
                        color: #0082ef;
                        cursor: pointer;
                    }
                }
            }

            .footer {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 15px 0;
                font-size: 14px;

                .footer-left {
                    color: #333;
                    display: flex;
                }

                .footer-right {
                    color: #0082EF;
                    cursor: pointer;

                    .van-icon {
                        font-size: 14px;
                    }
                }

                .base-button {
                    background: #eff3fb;
                    border-radius: 4px;
                    padding: 5px 18px;
                    color: #0082ef;
                    cursor: pointer;
                }
            }
        }
    }
}</style>